module.exports = __webpack_public_path__ + "static/media/donbosco6.6b8885db.jpg";